import { Grid, SectionHeader } from 'web-library';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGetSchoolCandidatePaymentReceipt } from '../../../../api-refactored/school-candidate-payment/useGetSchoolCandidatePaymentReceipt';
import ReceiptDetail from '../../../../components/ReceiptDetails';
import { useWOGAA } from '../../../../hooks/wogaa';

interface SchoolCandidatePaymentReceiptPathParams {
  uuid: string;
}

const SchoolCandidatePaymentReceipt = () => {
  const { uuid } = useParams<SchoolCandidatePaymentReceiptPathParams>();
  const { data } = useGetSchoolCandidatePaymentReceipt({ uuid });
  const { t } = useTranslation();

  const { transactionEnd } = useWOGAA('myexamsseab-6469');
  const { transactionEnd: transactionEndAppeal } = useWOGAA('myexamsseab-6470');
  transactionEnd(uuid);
  transactionEndAppeal(uuid);

  return (
    <>
      <Grid container>
        <Grid xs={12}>
          <SectionHeader title={t('exam->>ExamReceipt.PaymentSummary')} />
        </Grid>
      </Grid>

      <ReceiptDetail
        transaction={{
          transactionNumber: data?.transactionNo || '',
          internalTransactionRef: data?.referenceNo,
          totalFee: data?.totalExamFee || '0',
          paymentMethod: data?.paymentMethod || '',
          paymentTimeStamp: data?.paymentDateTime || '',
          gstRegNo: data?.gstRegNo,
        }}
      />
    </>
  );
};

export default SchoolCandidatePaymentReceipt;
